var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Navigator } from '../../../ts/components/Navigator';
import { FrontPage } from '../../pages/front-page';
import { ProjectManager } from '../Project';
export class Header extends Component {
    constructor() {
        super('Header', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-toggle-menu').on('click', (event, button) => {
                event.preventDefault();
                if (button.hasClass('is-active')) {
                    if (button.data('action') === 'close-project-informations') {
                        ProjectManager.closeProjectInformations();
                    }
                    else if (button.data('action') === 'close-impressum') {
                        button.data('action', 'default');
                        if ($(window).width() < 992) {
                            Navigator.navigate('/a-propos/', 'link');
                        }
                        else {
                            Navigator.navigate('/contact/', 'link');
                        }
                    }
                    else {
                        Navigator.navigate($('.project').eq(FrontPage.projectIndex).find('a').first().attr('href'), 'scroll', FrontPage.projectIndex);
                    }
                }
                else {
                    Navigator.navigate(button.attr('href'), 'link');
                }
                $('.header-logo').addClass('d-lg-none');
            }).on('mouseenter', (event, button) => {
                if (button.hasClass('is-active') || $(window).width() < 992)
                    return;
                $('.header-logo').removeClass('d-lg-none');
            }).on('mouseleave', (event, button) => {
                if ($(window).width() < 992)
                    return;
                $('.header-logo').addClass('d-lg-none');
            });
            $('body').on('click', '#dynamic-page-content menu a, #dynamic-page-content .impressum-link', (event, link) => {
                event.preventDefault();
                Navigator.navigate(link.attr('href'), 'link');
                if (link.hasClass('impressum-link'))
                    $('.btn-toggle-menu').data('action', 'close-impressum');
            });
            this.success();
        });
    }
}
